<template>
  <div>

    <div class="mb-4">
      <CheckboxGroup
          class="d-inline-block mb-0 align-middle cat-checkbox pointer"
          @input="allCheckedClicked"
          :value="allChecked"
          fid="all">
        <div class="form-label ml-10">{{ $t('all_rights') }}</div>
      </CheckboxGroup>
    </div>

    <div class="row tickboxes-h-auto mb-4" v-for="(arr, cat) in allFunctions"
           :key="`cat-${cat}`">
      <div class="col-12">
        <div class="mb-3">

          <CheckboxGroup
              class="d-inline-block mb-0 align-middle cat-checkbox pointer"
              @input="catChecked(cat)"
              :value="catsChecked[cat]"
              :fid="`cat-${cat}`">
            <span class="font-weight-bold ml-10">{{ $t(cat) }}</span>
          </CheckboxGroup>
        </div>
      </div>
      <div class="col-md-6 col-12"
           v-for="f in arr"
           :key="`all_function_${f.id}`">
        <CheckboxGroup :label="f.title"
                       :checkboxvalue="f.id"
                       :fid="`checkbox-f-${f.id}`"
                       v-model="object.functionIds">
          <a v-if="f.note"
             :title="f.note"
             class="info ml-2"
             v-b-tooltip.hover>
            <InfoSvg class="info-svg"/>
          </a>
        </CheckboxGroup>
      </div>
    </div>
  </div>
</template>

<script setup>
import CheckboxGroup from "@/components/form/CheckboxGroup.vue"
import InfoSvg from "@/assets/svg-vue/general/question.svg.vue"

import { computed } from "vue"

const { object, selectOptions } = defineProps({
  object: {
    type: Object,
    required: true
  },
  selectOptions: {
    type: Object,
    required: true
  }
})

const allFunctions = computed(() => {
  const functions = selectOptions.all_functions
  const order = [
    'general',
    'calendar',
    'treatment',
    'staff',
    'communications',
    'finance',
    'reports',
    'egisz',
    'additional_modules'
  ]
  return Object.keys(functions).sort(function(a,b) {
    return order.indexOf(a) - order.indexOf(b)
  }).reduce((obj, key) => {
        obj[key] = functions[key]
        return obj
      }, {}
  )
})

const catsChecked = computed(() => {
  const arr = {}
  for(const cat in allFunctions.value) {
    arr[cat] = allFunctions.value[cat].every(f => object.functionIds.includes(f.id))
  }
  return arr
})

const catChecked = (cat) => {
  const funcs = allFunctions.value[cat] || []
  const selectedPreviously = catsChecked.value[cat]
  funcs.forEach((f) => {
    if(selectedPreviously) {
      const index = object.functionIds.indexOf(f.id)
      if(index > -1) {
        object.functionIds.splice(index, 1)
      }
    } else {
      if(!object.functionIds.includes(f.id)) {
        object.functionIds.push(f.id)
      }
    }
  })
}

const allChecked = computed(() => {
  return Object.values(catsChecked.value).every(cat => cat === true)
})

const allCheckedClicked = () => {
  if(allChecked.value) {
    object.functionIds = []
  } else {
    object.functionIds = Object.values(selectOptions.all_functions).flat().map(obj => obj.id)
  }
}
</script>

<style lang="scss" scoped>
.tickboxes-h-auto {
  ::v-deep label {
    height: auto;
  }
}
</style>
